import {
  EMPTY_RECEIPT_CLAIM_DRAFT,
  type ReceiptClaimDraft,
} from "@nmible-ltd/claims";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * In-progress receipt claim wizard state. Lives in Redux (not page `useState`)
 * so it survives a remount of the route subtree when the participant navigates
 * back to the flow. Blacklisted from redux-persist (see `store/store.ts`): kept
 * in memory only and cleared at the flow boundaries by `useClaimDraftCleanup`
 * and the new-claim menu.
 *
 * `pdf` stays `null` here. The PDF receipt is kept on the device by
 * `pdfReceiptDraft`, so a refresh brings it back.
 */
export type ReceiptClaimDraftState = ReceiptClaimDraft;

export const receiptClaimDraftSlice = createSlice({
  name: "receiptClaimDraft",
  initialState: EMPTY_RECEIPT_CLAIM_DRAFT,
  selectors: {
    selectReceiptClaimDraft: (state) => state,
  },
  reducers: {
    patchReceiptClaimDraft: (
      state,
      action: PayloadAction<Partial<ReceiptClaimDraftState>>
    ) => {
      Object.assign(state, action.payload);
    },
    resetReceiptClaimDraft: () => EMPTY_RECEIPT_CLAIM_DRAFT,
  },
});

export const { selectReceiptClaimDraft } = receiptClaimDraftSlice.selectors;

export const { patchReceiptClaimDraft, resetReceiptClaimDraft } =
  receiptClaimDraftSlice.actions;
